(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const badgeSelector = '.cs-rider-height[data-dynamic-option-position]';

    const updateBadge = (badge) => {
      const section = badge.closest('.cs-product-main-section');
      const label = badge.querySelector('.cs-rider-height__text');
      const description = badge.querySelector('.cs-rider-height__description');
      if (!section || !label) return;

      const position = badge.dataset.dynamicOptionPosition;
      const selectedOption = section.querySelector(
        `.product_accessory_sku.accessory_sku_active[data-position="${position}"]`
      );
      const selectedValue = selectedOption?.dataset.value || '';
      const nextText = selectedValue === badge.dataset.dynamicOptionValue
        ? badge.dataset.alternateText
        : badge.dataset.defaultText;
      const nextDescription = selectedValue === badge.dataset.dynamicOptionValue
        ? badge.dataset.alternateDescription
        : badge.dataset.defaultDescription;
      if (label.textContent !== nextText) label.textContent = nextText;
      if (description && description.textContent !== nextDescription) description.textContent = nextDescription;
    };

    const initializeBadges = (root = document) => {
      root.querySelectorAll(badgeSelector).forEach(updateBadge);
    };

    if (window.macfoxRiderHeightBadgeInitialized) {
      initializeBadges();
      return;
    }
    window.macfoxRiderHeightBadgeInitialized = true;

    document.addEventListener('click', (event) => {
      const option = event.target.closest('.product_accessory_sku[data-position]');
      if (!option) return;

      const section = option.closest('.cs-product-main-section');
      const badge = section?.querySelector(badgeSelector);
      if (!badge || option.dataset.position !== badge.dataset.dynamicOptionPosition) return;

      queueMicrotask(() => updateBadge(badge));
    });

    document.addEventListener('shopify:section:load', (event) => initializeBadges(event.target));
    initializeBadges();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["macfox-gift-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('macfox-gift-compare')) {
    customElements.define('macfox-gift-compare', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const stage = this.querySelector('.mfx-gift__stage');
        const range = this.querySelector('input[type="range"]');
        const beforeLabel = this.querySelector('.mfx-gift__state--before');
        const afterLabel = this.querySelector('.mfx-gift__state--after');
        if (!stage || !range) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const section = this.closest('.mfx-gift');
        const introHeading = section.querySelector('.mfx-gift__title');
        const mobileIntro = window.matchMedia('(max-width: 767px)');
        const buttons = Array.from(section.querySelectorAll('[data-gift-target]'));
        const markers = Array.from(this.querySelectorAll('[data-gift-marker]'));
        const bikeImages = Array.from(this.querySelectorAll('.mfx-gift__bike'));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let selected = null;
        let pointer = null;
        let startX = 0;
        let startY = 0;
        let dragging = false;
        let scrolling = false;
        let dragOffset = 0;
        let touchId = null;
        let touchGesture = false;
        let scrollLock = null;
        let visualPosition = Number(range.value);
        let pendingPosition = null;
        let stageLeft = 0;
        let stageWidth = 0;
        let beforeLimit = 0;
        let afterLimit = 100;
        let lastAccessibleValue = null;
        const clamp = value => Math.min(100, Math.max(0, value));
        const ease = value => value * value * value * (value * (value * 6 - 15) + 10);
        const cancelPointerUpdate = () => {
          cancelAnimationFrame(this.pointerFrame);
          this.pointerFrame = null;
          pendingPosition = null;
        };
        const stopAnimation = () => {
          cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
          this.classList.remove('is-revealing');
        };
        const highlight = (id) => {
          buttons.forEach(button => {
            button.classList.toggle('is-highlighted', button.dataset.giftTarget === id);
            button.setAttribute('aria-pressed', String(button.dataset.giftTarget === selected));
          });
          markers.forEach(marker => marker.classList.toggle('is-highlighted', marker.dataset.giftMarker === id));
        };
        const clearSelection = () => {
          selected = null;
          highlight(null);
        };
        const render = (position) => {
          visualPosition = clamp(position);
          const value = Math.round(visualPosition);
          beforeLabel?.classList.toggle('is-obscured', visualPosition < beforeLimit);
          afterLabel?.classList.toggle('is-obscured', visualPosition > afterLimit);
          this.style.setProperty('--gift-position', visualPosition + '%');
          const pixelRatio = window.devicePixelRatio || 1;
          const offset = Math.min(stageWidth, Math.max(0, Math.round((stageLeft + stageWidth * visualPosition / 100) * pixelRatio) / pixelRatio - stageLeft));
          this.style.setProperty('--gift-offset', offset + 'px');
          if (Number(range.value) !== value) range.value = value;
          if (lastAccessibleValue !== value) {
            range.setAttribute('aria-valuetext', this.dataset.valueText.replace('[value]', value));
            lastAccessibleValue = value;
          }
        };
        const measure = () => {
          const bounds = stage.getBoundingClientRect();
          stageLeft = bounds.left;
          stageWidth = bounds.width;
          if (!stageWidth) return;
          beforeLimit = beforeLabel ? (beforeLabel.offsetLeft + beforeLabel.offsetWidth + 8) / stageWidth * 100 : 0;
          afterLimit = afterLabel ? (afterLabel.offsetLeft - 8) / stageWidth * 100 : 100;
          render(visualPosition);
        };
        let introVisible = false;
        let introHeadingSeen = false;
        let introHeadingVisible = false;
        let introStageRatio = 0;
        const imagesReady = () => bikeImages.every(image => image.complete && image.naturalWidth > 0);
        const pauseIntro = () => {
          cancelAnimationFrame(this.introFrame);
          this.introFrame = null;
          this.classList.remove('is-demonstrating');
        };
        const stopIntro = () => {
          this.introPlayed = true;
          pauseIntro();
          this.introObserver?.disconnect();
          this.introObserver = null;
        };
        const playIntro = () => {
          if (this.introPlayed || this.introFrame != null || pointer !== null || !introVisible || document.hidden || reducedMotion.matches || !imagesReady()) return;
          measure();
          const from = visualPosition;
          const points = [from, Math.min(100, from + 24), Math.max(0, from - 16), from];
          const started = performance.now();
          this.classList.add('is-demonstrating');
          const step = (now) => {
            if (reducedMotion.matches) {
              stopIntro();
              return;
            }
            if (!this.isConnected || document.hidden || !introVisible || !imagesReady()) {
              pauseIntro();
              return;
            }
            const elapsed = Math.min(3000, now - started);
            const segment = Math.min(2, Math.floor(elapsed / 1000));
            const progress = (elapsed - segment * 1000) / 1000;
            render(points[segment] + (points[segment + 1] - points[segment]) * ease(progress));
            if (elapsed < 3000) this.introFrame = requestAnimationFrame(step);
            else stopIntro();
          };
          this.introFrame = requestAnimationFrame(step);
        };
        bikeImages.forEach(image => {
          image.addEventListener('load', playIntro, options);
          image.addEventListener('error', pauseIntro, options);
        });
        range.addEventListener('focusin', stopIntro, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.releasePointer?.();
            if (this.introFrame != null) pauseIntro();
            stopAnimation();
            cancelPointerUpdate();
          } else playIntro();
        }, options);
        reducedMotion.addEventListener('change', () => {
          if (reducedMotion.matches) {
            stopIntro();
            stopAnimation();
            cancelPointerUpdate();
          }
        }, options);
        if (!this.introPlayed && !reducedMotion.matches && 'IntersectionObserver' in window) {
          const updateIntroVisibility = () => {
            introVisible = mobileIntro.matches && introHeading
              ? introHeadingSeen && (introHeadingVisible || introStageRatio > 0)
              : introStageRatio >= 0.5;
            if (introVisible) playIntro();
            else if (this.introFrame != null) pauseIntro();
          };
          this.introObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.target === stage) introStageRatio = entry.isIntersecting ? entry.intersectionRatio : 0;
              if (entry.target === introHeading) {
                introHeadingVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
                if (introHeadingVisible) introHeadingSeen = true;
              }
            });
            updateIntroVisibility();
          }, { threshold: [0, 0.5] });
          this.introObserver.observe(stage);
          if (introHeading) this.introObserver.observe(introHeading);
          mobileIntro.addEventListener('change', updateIntroVisibility, options);
        }
        const reveal = (id) => {
          const marker = markers.find(item => item.dataset.giftMarker === id);
          if (!marker) return;
          const bounds = stage.getBoundingClientRect();
          if (!bounds.width) return;
          const target = clamp((marker.getBoundingClientRect().left - bounds.left - 64) / bounds.width * 100);
          const from = visualPosition;
          if (from <= target) return;
          stopAnimation();
          if (reducedMotion.matches) {
            render(target);
            return;
          }
          const started = performance.now();
          this.classList.add('is-revealing');
          const step = (now) => {
            const progress = Math.min(1, (now - started) / 360);
            render(from + (target - from) * ease(progress));
            if (progress < 1) this.animationFrame = requestAnimationFrame(step);
            else stopAnimation();
          };
          this.animationFrame = requestAnimationFrame(step);
        };
        buttons.forEach(button => {
          const id = button.dataset.giftTarget;
          button.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') highlight(id);
          }, options);
          button.addEventListener('pointerleave', () => {
            const focused = buttons.find(item => item === document.activeElement);
            highlight(focused ? focused.dataset.giftTarget : selected);
          }, options);
          button.addEventListener('focus', () => {
            stopIntro();
            highlight(id);
          }, options);
          button.addEventListener('blur', () => highlight(selected), options);
          button.addEventListener('click', () => {
            stopIntro();
            stopAnimation();
            cancelPointerUpdate();
            selected = selected === id ? null : id;
            highlight(selected);
            if (selected) reveal(selected);
          }, options);
          button.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              stopAnimation();
              clearSelection();
            }
          }, options);
        });
        const position = (event, immediate = false) => {
          if (!stageWidth) return;
          const value = clamp((event.clientX - stageLeft - dragOffset) / stageWidth * 100);
          if (immediate) {
            cancelPointerUpdate();
            render(value);
            return;
          }
          pendingPosition = value;
          if (this.pointerFrame != null) return;
          this.pointerFrame = requestAnimationFrame(() => {
            this.pointerFrame = null;
            if (pendingPosition !== null) render(pendingPosition);
            pendingPosition = null;
          });
        };
        range.addEventListener('input', () => {
          stopIntro();
          stopAnimation();
          cancelPointerUpdate();
          clearSelection();
          render(Number(range.value));
        }, options);
        range.addEventListener('keydown', event => {
          if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) {
            stopIntro();
            stopAnimation();
            cancelPointerUpdate();
            clearSelection();
          }
        }, options);
        const restoreStyles = (element, entries) => {
          entries.forEach(([name, value, priority]) => {
            if (value) element.style.setProperty(name, value, priority);
            else element.style.removeProperty(name);
          });
        };
        const lockPage = () => {
          if (!touchGesture || scrollLock) return;
          const root = document.documentElement;
          const body = document.body;
          if (!root || !body) return;
          const bodyWidth = body.getBoundingClientRect().width;
          const pageHeight = Math.max(root.scrollHeight, body.scrollHeight, root.clientHeight);
          const saveStyles = (element, names) => names.map(name => [name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)]);
          scrollLock = {
            x: window.scrollX,
            y: window.scrollY,
            root,
            body,
            rootStyles: saveStyles(root, ['min-height', 'scroll-behavior']),
            bodyStyles: saveStyles(body, ['position', 'top', 'left', 'right', 'bottom', 'width', 'height', 'max-height', 'box-sizing']),
            controller: new AbortController()
          };
          root.style.setProperty('min-height', pageHeight + 'px', 'important');
          root.style.setProperty('scroll-behavior', 'auto', 'important');
          const styles = {
            position: 'fixed',
            top: -scrollLock.y + 'px',
            left: -scrollLock.x + 'px',
            right: 'auto',
            bottom: 'auto',
            width: bodyWidth + 'px',
            height: 'auto',
            'max-height': 'none',
            'box-sizing': 'border-box'
          };
          Object.entries(styles).forEach(([name, value]) => body.style.setProperty(name, value, 'important'));
          const touchOptions = { signal: scrollLock.controller.signal, capture: true, passive: false };
          document.addEventListener('touchmove', event => {
            if (event.cancelable) event.preventDefault();
          }, touchOptions);
          document.addEventListener('touchend', endTouch, touchOptions);
          document.addEventListener('touchcancel', endTouch, touchOptions);
        };
        const unlockPage = () => {
          if (!scrollLock) return;
          const saved = scrollLock;
          scrollLock = null;
          saved.controller.abort();
          restoreStyles(saved.body, saved.bodyStyles);
          if (window.scrollX !== saved.x || window.scrollY !== saved.y) window.scrollTo(saved.x, saved.y);
          restoreStyles(saved.root, saved.rootStyles);
        };
        const beginDrag = () => {
          stopIntro();
          dragging = true;
          clearSelection();
          this.classList.add('is-dragging');
          if (touchGesture) lockPage();
          else range.focus({ preventScroll: true });
        };
        const claimDrag = event => {
          if (dragging) return true;
          if (scrolling) return false;
          const horizontal = Math.abs(event.clientX - startX);
          const vertical = Math.abs(event.clientY - startY);
          if (vertical >= 10 && vertical > horizontal * 1.25) {
            scrolling = true;
            return false;
          }
          if (horizontal < 4 || horizontal < vertical * 0.8) return false;
          beginDrag();
          return true;
        };
        stage.addEventListener('pointerdown', (event) => {
          if (pointer !== null || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          event.preventDefault();
          const onHandle = Boolean(event.target.closest?.('.mfx-gift__handle'));
          if (event.pointerType === 'touch' && !onHandle) pauseIntro();
          else stopIntro();
          stopAnimation();
          cancelPointerUpdate();
          measure();
          pointer = event.pointerId;
          startX = event.clientX;
          startY = event.clientY;
          scrolling = false;
          dragging = false;
          touchGesture = event.pointerType === 'touch';
          dragOffset = event.pointerType === 'touch' && onHandle ? event.clientX - stageLeft - stageWidth * visualPosition / 100 : 0;
          stage.setPointerCapture(pointer);
          if (event.pointerType !== 'touch' || onHandle) {
            beginDrag();
            position(event, true);
          }
        }, options);
        stage.addEventListener('pointermove', (event) => {
          if (event.pointerId !== pointer) return;
          if (!claimDrag(event)) return;
          if (event.cancelable) event.preventDefault();
          position(event);
        }, options);
        stage.addEventListener('touchstart', event => {
          if (event.touches.length === 1) touchId = event.touches[0].identifier;
          if (event.target.closest?.('.mfx-gift__handle') && event.cancelable) event.preventDefault();
        }, { ...options, passive: false });
        stage.addEventListener('touchmove', event => {
          if (pointer === null) return;
          const touch = Array.from(event.touches).find(item => item.identifier === touchId) || (touchId === null ? event.touches[0] : null);
          if (!touch || !claimDrag(touch)) return;
          if (event.cancelable) event.preventDefault();
          position(touch);
        }, { ...options, passive: false });
        const release = () => {
          cancelPointerUpdate();
          const captured = pointer;
          pointer = null;
          dragging = false;
          scrolling = false;
          dragOffset = 0;
          touchId = null;
          touchGesture = false;
          this.classList.remove('is-dragging');
          if (captured !== null && stage.hasPointerCapture(captured)) stage.releasePointerCapture(captured);
          unlockPage();
          playIntro();
        };
        this.releasePointer = release;
        stage.addEventListener('pointerup', event => {
          if (event.pointerId !== pointer) return;
          if (dragging) position(event, true);
          else if (!scrolling && Math.abs(event.clientX - startX) < 6 && Math.abs(event.clientY - startY) < 6) {
            stopIntro();
            clearSelection();
            if (!touchGesture) range.focus({ preventScroll: true });
            position(event, true);
          }
          release();
        }, options);
        const cancelPointer = event => {
          if (event.pointerId === pointer) release();
        };
        stage.addEventListener('pointercancel', cancelPointer, options);
        stage.addEventListener('lostpointercapture', cancelPointer, options);
        const endTouch = event => {
          if (pointer === null) return;
          const touch = Array.from(event.changedTouches).find(item => item.identifier === touchId);
          if (!touch && event.touches.length > 0) return;
          if (event.type === 'touchend' && dragging && touch) position(touch, true);
          release();
        };
        stage.addEventListener('touchend', endTouch, options);
        stage.addEventListener('touchcancel', endTouch, options);
        window.addEventListener('blur', release, options);
        window.addEventListener('pagehide', release, options);
        window.addEventListener('resize', measure, options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(measure);
          this.resizeObserver.observe(stage);
          if (beforeLabel) this.resizeObserver.observe(beforeLabel);
          if (afterLabel) this.resizeObserver.observe(afterLabel);
        }
        if (this.dataset.x7lVariants) {
          const x7lVariants = new Set(this.dataset.x7lVariants.split(',').filter(Boolean));
          const pictures = Array.from(this.querySelectorAll('[data-gift-picture]'));
          let showingX7l = this.dataset.x7lActive === 'true';
          const syncVariantImages = () => {
            const activeVariant = document.querySelector('#cs_product_main .product_img_active');
            if (!activeVariant?.dataset.id) return;
            const nextX7l = x7lVariants.has(activeVariant.dataset.id);
            if (nextX7l === showingX7l) return;
            pictures.forEach(picture => {
              const source = picture.querySelector('source');
              const image = picture.querySelector('img');
              source.srcset = (nextX7l ? picture.dataset.x7lMobileSrcset : picture.dataset.defaultMobileSrcset) || (nextX7l ? picture.dataset.x7lMobile : picture.dataset.defaultMobile);
              image.srcset = (nextX7l ? picture.dataset.x7lDesktopSrcset : picture.dataset.defaultDesktopSrcset) || '';
              image.src = nextX7l ? picture.dataset.x7lDesktop : picture.dataset.defaultDesktop;
            });
            markers.forEach(marker => {
              marker.style.setProperty('left', (nextX7l ? marker.dataset.x7lX : marker.dataset.defaultX) + '%');
              marker.style.setProperty('top', (nextX7l ? marker.dataset.x7lY : marker.dataset.defaultY) + '%');
            });
            showingX7l = nextX7l;
            this.dataset.x7lActive = String(nextX7l);
          };
          document.addEventListener('click', event => {
            const choice = event.target.closest?.('#cs_product_main .product_accessory_sku');
            if (!choice || choice.classList.contains('sku_disabled')) return;
            cancelAnimationFrame(this.variantImageFrame);
            this.variantImageFrame = requestAnimationFrame(() => {
              this.variantImageFrame = null;
              if (!options.signal.aborted && this.isConnected) syncVariantImages();
            });
          }, { ...options, capture: true });
          syncVariantImages();
        }
        measure();
        render(visualPosition);
      }
      disconnectedCallback() {
        this.releasePointer?.();
        this.releasePointer = null;
        if (this.controller) this.controller.abort();
        cancelAnimationFrame(this.animationFrame);
        cancelAnimationFrame(this.introFrame);
        cancelAnimationFrame(this.pointerFrame);
        cancelAnimationFrame(this.variantImageFrame);
        this.introObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.animationFrame = null;
        this.introFrame = null;
        this.introObserver = null;
        this.pointerFrame = null;
        this.variantImageFrame = null;
        this.resizeObserver = null;
        this.classList.remove('is-dragging', 'is-demonstrating', 'is-revealing');
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
